import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate, showMessageToastCustom, getUserNameToName, formatData } from '../../../../utils/util';
import { validateInputsRequired, onValueChange } from '../../../../utils/handleChangeHooks';
import { Breadcrumbs, Button, Card, Input, Label } from '../../../../components/UI/ComponentsUI';
import StockService from '../../../../services/StockService';
import ModalUploadPartnumbers from './ModalUploadPartnumbers';

const PartnumberInsert = (props) => {
    const update = props.location?.state?.update;
    const [openModal, setOpenModal] = useState(false)
    const [partnumber, setPartnumber] = useState(props.location?.state?.update && props.partnumber
        ? props.partnumber : {
            multiple: false,
            qtMultiple: 1
        });

    const onChange = (event) => {
        onValueChange(event, partnumber, setPartnumber);
    };

    const onConfirm = () => {
        partnumber.qtMultiple = partnumber.qtMultiple ? partnumber.qtMultiple.toFixed(2) : partnumber.qtMultiple;
        if (validateInputsRequired("formMovementTypeInsert")) {
            if (update) {
                props.partnumberUpdate(partnumber, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), translate('sucess-to-update', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            } else {
                props.partnumberInsert(partnumber, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), translate('sucess-to-include', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            }
        }
    };

    const titleMovementType = { icon: "mdi mdi-clipboard-check-outline", label: translate('menu.partnumbers', 'configuration') };
    const subtitlesMovementType = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-repeat", label: translate('partnumber', 'stock') }];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }];
        return subtitlesItems;
    }

    const handleOnKeyUp = (e) => {
        let value = e.target.value;
        var parts = value.toString().split('.');
        if (parts && parts[1] && parts[1].length > 2) {
            let newValue = parseFloat(value).toFixed(2)
            e.target.value = newValue;
        }
    }




    return (
        <div>
            <Breadcrumbs id="partnumberinsert" title={titleMovementType} subtitles={subtitlesMovementType()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <Card>
                        <form id="formMovementTypeInsert">
                            <div className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        id="partnumbercode"
                                        name='partnumbercode'
                                        required
                                        label={translate('stock:partnumber')}
                                        type="text"
                                        defaultValue={partnumber?.partnumberCode || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        required
                                        id="area"
                                        name='area'
                                        label={translate('stock:area')}
                                        type="text"
                                        defaultValue={partnumber?.area || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s3">
                                    <Input
                                        id="multiple"
                                        name="multiple"
                                        type="checkbox"
                                        label={translate('stock:multiple-diffusion')}
                                        onChange={onChange}
                                        defaultChecked={partnumber?.multiple}
                                    />
                                </div>
                                {partnumber?.multiple &&
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            required={partnumber?.multiple}
                                            id="qtMultiple"
                                            name="qtMultiple"
                                            onKeyUp={(e) => handleOnKeyUp(e)}
                                            type="number"
                                            label={translate('stock:qt-diffusion')}
                                            onChange={onChange}
                                            defaultValue={partnumber?.qtMultiple}
                                            step=".01"
                                        />
                                    </div>
                                }
                            </div>
                            <div className="input-field no-padding  col s1">
                                <button
                                    className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                    type="button"
                                    onClick={() => setOpenModal(true)}>
                                    <i className="Small material-icons">cloud_upload</i>
                                </button>
                            </div>
                        </form>
                        <div className="row" style={{ paddingTop: '10px' }}>
                            {update &&
                                <>
                                    <Label label={translate('fields.updateBy', 'movement-type')} id="updateBy" value={getUserNameToName(props?.usersFromElog, partnumber?.updatedBy)} />
                                    <Label label={translate('fields.updateOn', 'movement-type')} id="updateOn" value={formatData(partnumber?.updatedOn)} />
                                </>
                            }
                            <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                            <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                        </div>
                    </Card>
                </div>
            </div >
            <ModalUploadPartnumbers
                open={openModal}
                id="ModalUploadPartnumbers"
                onCancel={() => setOpenModal(false)}
                onClose={() => setOpenModal(false)}
                onConfirm={() => setOpenModal(false)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        partnumber: state.stockReducer.partnumber,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        partnumberInsert: (partnumber, callback) => {
            dispatch(StockService.addPartnumber(partnumber, callback));
        },
        partnumberUpdate: (partnumber, callback) => {
            dispatch(StockService.editPartnumber(partnumber, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PartnumberInsert)));
